<template>
    <div id="app">
        <div v-bind:class="{dn:(is_hide_success && is_hide_warning && is_hide_error)}" class="messages-content">
            <div v-bind:class="{ dn:is_hide_success }" class="message success">{{success_message}} <span v-on:click="is_hide_success=true" class="close">X</span></div>
            <div v-bind:class="{ dn:is_hide_warning }"  class="message warning">{{warning_message}} <span  v-on:click="is_hide_warning=true" class="close">X</span></div>
            <div v-bind:class="{ dn:is_hide_error }"  class="message error">{{error_message}} <span  v-on:click="is_hide_error=true" class="close">X</span></div>
        </div>
        <router-view/>
    </div>
</template>

<script>
    import {bus} from './main'
    import Store from './store'
    export default {
        name: 'App',
        data() {
            return {
                success_message:'',
                warning_message:'',
                error_message:'',
                is_hide_success:true,
                is_hide_warning:true,
                is_hide_error:true,
                success_interval:null,
                warning_interval:null,
                error_interval:null,
            }
        },
        mounted() {
        },
        methods: {
            hideSuccess(){
                this.is_hide_success = true;
            },
            hideWarning(){
                this.is_hide_warning = true;
            },
            hideError(){
                this.is_hide_error = true;
            },
        },
        created() {
            bus.$on('logout' , ()=>{
                Store.commit('setAuthenticated' , false);
                this.$router.replace({ name: "login" });
            });
            bus.$on('alert-success' , (msg,option)=>{
                this.success_message = msg;
                this.is_hide_success=false;
                clearInterval(this.success_interval);
                if(option && option.time){
                    this.success_interval = setTimeout(this.hideSuccess, option.time);
                }else {
                    this.success_interval = setTimeout(this.hideSuccess, 5000);
                }
            });
            bus.$on('alert-warning' , (msg,option)=>{
                this.warning_message = msg;
                this.is_hide_warning=false;
                clearInterval(this.warning_interval);
                if(option && option.time){
                    this.warning_interval = setTimeout(this.hideWarning, option.time);
                }else {
                    this.warning_interval = setTimeout(this.hideWarning, 5000);
                }
            });
            bus.$on('alert-error' , (msg,option)=>{
                this.error_message = msg;
                this.is_hide_error=false;
                clearInterval(this.error_interval);
                if(option && option.time){
                    this.error_interval = setTimeout(this.hideError, option.time);
                }else {
                    this.error_interval = setTimeout(this.hideError, 5000);
                }
            });
        },

    }
</script>

<style>
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }
    .dn{
        display: none;
    }
    .dni{
        display: none!important;
    }
    .nl2br{
        white-space: pre;
    }
</style>

<style scoped>
    .messages-content{
        top: 8%;
        position: fixed;
        z-index: 9999;
        max-width: 550px;
        margin: 10px auto;
        right: 0;
        left: 0;
        font-size: 16px;
        text-shadow: 2px 2px
        rgba(158, 158, 158, 0.12);
        max-height: 85%;
        overflow: auto;
    }
    .message{
        margin: 2px;
        border-radius: 5px;
        padding: 7px;
    }
    .success{
        background-color: green;
    }
    .warning{
        background-color: orange;
    }
    .error{
        background-color: red;
    }
    .close{
        float: right;
        font-weight: 700;
        line-height: 1;
        color: #000;
        filter: alpha(opacity=20);
        opacity: .3;
        padding: 0 3px;
        border: 1px black solid;
        cursor: pointer;
    }
</style>